module.exports = __webpack_public_path__ + "static/img/QREN.9e431cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/general/QREN.png
// module id = FI+m
// module chunks = 0